var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[_vm._l((_vm.model.meta),function(value,key){return _c('div',{key:key},[_vm._v("\n    "+_vm._s(_vm.translation[key])+": "+_vm._s(value)+"\n  ")])}),_vm._v(" "),_c('div',[_vm._v("\n    User-Agent: "),_c('br'),_vm._v("\n    "+_vm._s(_vm.model.user_agent)+"\n  ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }